export default {
  data: {
    active: false,
    count: 0,
    total: 0,
    msg: ''
  },
  start({ count, total, msg }) {
    Object.assign(this.data, { count, total, msg, active: true })
  },
  count(count) {
    Object.assign(this.data, { count: count })
  },
  end() {
    Object.assign(this.data, { active: false, count: 0, total: 0 })
  }
}
